export default function () {
    // nothing to run
}
